interface Props {
  activePage: string
}

export function MarketingNavigation({ activePage }: Props) {
  const pages = ["Go", "Download", "Affiliate", "Support"]

  return (
    <div className="mk-nav">
      <div className="mk-nav-bar">
        <a href="https://totodo.app/" className="mk-nav-logo">
          <img src="/logos/company-icon.png" alt="To To-Do" />
          <span>To To-Do</span>
        </a>
        <div className="mk-nav-links">
          {pages.map((page) => (
            <a
              key={page}
              href={`/${page.toLowerCase()}`}
              className={activePage === page ? "active" : ""}
            >
              {page}
            </a>
          ))}
        </div>
        <div className="mk-nav-action">
          <a href="https://totodo.app/">Start for free</a>
        </div>
      </div>
    </div>
  )
}
